import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from "./store";
import axios from 'axios'
import VueAxios from 'vue-axios'
import Notifications from 'vue-notification'
import 'popper.js'
import {
	domain,
	clientId
} from "../auth_config.json";
import {
	Auth0Plugin
} from "./auth";
import VueCurrencyInput from 'vue-currency-input';
import {
	makeServer
} from "./mirageServer"


const pluginOptions = {
	/* see config reference */
	globalOptions: {
		currency: 'USD'
	}
}
Vue.use(VueCurrencyInput, pluginOptions);


Vue.use(Auth0Plugin, {
	domain,
	clientId,
	onRedirectCallback: appState => {
		router.push(
			appState && appState.targetUrl ?
			appState.targetUrl :
			window.location.pathname
		);
	}
});

Vue.config.productionTip = false

Vue.use(VueAxios, axios)
Vue.use(Notifications)

if (process.env.NODE_ENV === "demo") {
	makeServer();
}

new Vue({
	router,
	store,
	render: h => h(App),
	components: {
		App
	}
}).$mount('#app')
